import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";


export const getCustomer_Data_Report = async(param:any )=>{
   const response = await axiosInstance.get(`${API_ENDPOINTS.Reports.GET_CUSTOMER_DATA_REPORT}`,{params:param});
   const rowData = response?.data;    
   // console.log('rowData',rowData?.data?.CustomerReportData);
   // console.log('rowData',rowData?.data?.Pagination?.TotalCounts);
   
   const formatedData =  Array.isArray(rowData?.data?.CustomerReportData ||{})?
   rowData?.data?.CustomerReportData.map((item:any)=>(
   {
    EmployeeCode:item.EmployeeCode,
    FirstName:item.FirstName,
    LastName:item.LastName,
    Phone:item.Phone,
    "PositionCode": "108307",
    "OodItownid": 16579,
    OodTownCode:item.OodTownCode,
    "OutletOrgId": 1167128,
    "OrgUnitId": 34,
    "Id": 2019045,
    OutletCode:item.OutletCode,
    OutletOrgCode:item.OutletOrgCode,
    "TerritoryId": 5102,
    TerritoryName:item.TerritoryName,
    "PositionId": 764,
    PositionName:item.PositionName,
    "BeatId": 78115,
    BeatName:item.BeatName,
    Tags:item.Tags,
    VisitFq:item.VisitFq,
    Comments:item.Comments,
    OrgPotential:item.OrgPotential,
    BrandFocus:item.BrandFocus,
    CustomerFq:item.CustomerFq,
    OutletName:item.OutletName,
    OutletEmail:item.OutletEmail,
    OutletSalutation:item.OutletSalutation,
    OutletClassification:item.OutletClassification,
    Classification:item.Classification,
    OutletOpeningDate:item.OutletOpeningDate,
    OutletContactName:item.OutletContactName,
    OutletLandlineNo:item.OutletLandlineno,
    OutletAltLandlineNo:item.OutletAltLandlineno,
    OutletContactBday:item.OutletContactBday,
    OutletContactAnniversary:item.OutletContactAnniversary,
    "OutletIsdCode": "+91",
    OutletContactNo:item.OutletContactNo,
    OutletAltContactNo:item.OutletAltContactNo,
    "outlettype_id": 194,
    OutletTypeName:item.OutlettypeName,
    OutletPotential:item.OutletPotential,
    OutletQualification:item.OutletQualification,
    OutletRegNo:item.OutletRegno,
    OutletMaritalStatus:item.OutletMaritalStatus,
    OutletMedia:item.OutletMedia,
    AddressName:item.AddressName,
    OutletAddress:item.OutletAddress,
    OutletStreetName:item.OutletStreetName,
    Outletcity:item.OutletCity,
    OutletState:item.OutletState,
    OutletCountry:item.OutletCountry,
    OutletPincode:item.OutletPincode,
    LastVisitDate:item.LastVisitDate,
    LastVisitEmployee:item.LastVisitEmployee,
    OutletStatus:item.OutletStatus
}
   )):[]
   //  console.log('formatedData',formatedData);
    return{formatedData,rowData};
}

export const getPositionList= async(params={})=>{
  let respone = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_POSITION_LIST,{params:params});
  const rowData = await respone.data; 
  const formatedData = Array.isArray(rowData.data.Positions)? rowData.data.Positions.map((item:any)=>({
    id:item.PositionId,
    label:item.PositionName
  })) :[]
  return{formatedData,rowData}
}
